import { useState, useEffect } from 'react';
import { Link, List, ListItemButton, ListItemIcon, ListItemText } from '@mui/material';
import CAppDialog from '../../../app/components/CAppDialog';
import ReactPlayer from 'react-player';
import { AppIconPlayer } from '../../../app/features/icon/AppIcon';
import { useTranslation } from 'react-i18next';
import langMiscPlayerVideoTuto from '../langs/langMiscPlayerVideoTuto';
import { globalConfig } from '../../../app/config/config';

const VMiscPlayerVideoTuto = () => {
	const [isOpen, setIsOpen] = useState(false);
	const [isPlaying, setIsPlaying] = useState(false);
	const { t, i18n } = useTranslation();

	const [url, setUrl] = useState<string | null>(null);
	useEffect(() => {
		if (i18n) {
			if (i18n.language === 'fr' && globalConfig.get().APP_VIDEO_TUTO_URL_FR !== '') {
				setUrl(globalConfig.get().APP_VIDEO_TUTO_URL_FR);
			} else if (i18n.language === 'en' && globalConfig.get().APP_VIDEO_TUTO_URL_EN !== '') {
				setUrl(globalConfig.get().APP_VIDEO_TUTO_URL_EN);
			} else {
				setUrl(null);
			}
		}
	}, [t, i18n]);

	return (
		<>
			<CAppDialog
				id="misc-player-video-tuto-dialog"
				onClose={() => {
					setIsPlaying(false);
					setIsOpen(false);
				}}
				open={isOpen}
				title={t(langMiscPlayerVideoTuto.title.tag)}
				sx={{ padding: '0px', '& .MuiDialogContent-root': { padding: '0px 30px!important' } }}
			>
				<ReactPlayer
					id="misc-player-video-tuto-player"
					playing={isPlaying}
					url={url ?? undefined}
					width="100%"
					height="60vh"
					controls
					config={{
						file: {
							attributes: {
								controlsList: 'nodownload',
							},
						},
					}}
				/>
			</CAppDialog>
			<List>
				<ListItemButton
					id="menu-misc-player-video-tuto"
					// style={{ ...props.style, ...extendStyle }}
					// selected={menuItem.isActive}
					// key={menuItem.id}
					component={Link}
					onClick={() => {
						setIsPlaying(true);
						setIsOpen(true);
					}}
				>
					<ListItemIcon>
						<AppIconPlayer />
					</ListItemIcon>
					<ListItemText primary={t(langMiscPlayerVideoTuto.btn_open_player.tag)} />
				</ListItemButton>
			</List>
		</>
	);
};

export default VMiscPlayerVideoTuto;
